import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { SsoAccountData } from "../domain/models/sso-account.model";
import { SsoAccountFacade } from "../domain/+state/sso-account.facade";
import { take } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class SsoAccountCurrentResolver implements Resolve<SsoAccountData> {
  constructor(private readonly ssoAccountFacade: SsoAccountFacade) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SsoAccountData> {
    return this.ssoAccountFacade.getCurrentSsoAccount$().pipe(take(1));
  }
}
